function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148654",
  "data-name": "Path 148654",
  d: "M1.563,11.819a1.225,1.225,0,0,0,1.38,1.363H4.934a1.91,1.91,0,0,1,1.8.916,4.832,4.832,0,0,0,3.914,1.94H12.8a.7.7,0,0,0,.752-.741V13.872h3.031a.981.981,0,1,0,0-1.963H13.548V9.444h3.031a.981.981,0,1,0,0-1.963H13.548V6.017a.7.7,0,0,0-.752-.73H10.647a4.824,4.824,0,0,0-3.914,1.94,1.9,1.9,0,0,1-1.8.922H2.943a1.221,1.221,0,0,0-1.38,1.357Z",
  transform: "translate(-1.563 -5.287)",
  fill: "#ff0660"
});

function SvgElectricPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10.751,
    viewBox: "0 0 16 10.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricPlug);
export default __webpack_public_path__ + "static/media/electric-plug.862d7024.svg";
export { ForwardRef as ReactComponent };